<template>
    <article class="w-full py-35 px-40 has-background bg-white"
             :class="{ 'o-container--bleed': parentAlias }">
        <div>
            <div class="w-full break-words">
                <button v-if="showTranslationButton"
                        type="button"
                        class="c-product-details--translate theme-text-linkcolor c-product-details--translate--active mb-20 bg-gray-300 p-10 w-full text-left"
                        @click="translateDescription">
                    <CIcon name="g-translate"/>
                    <span class="c-product-details--translate-text">{{ labelForTranslateDescription }}</span>
                </button>

                <section ref="htmlContentRef"
                         v-delegate-html-links
                         v-delegate-on-img-error
                         class="wysiwyg text-block"
                         v-html="bodyText(showTranslated ? translatedContent?.translatedContent || content.content : content.content)"/>
            </div>
        </div>
    </article>
</template>

<script setup lang="ts">
import { PropType, computed, ref } from 'vue';
import { LegalContentBlockViewModel } from '@/types/contentServerContract';
import SmartHeadline from '@/core/ui-components/SmartHeadline.vue';
import tableHtmlService from './tableHtml.service';
import dictionaryService from '@/core/translation/dictionary.service';
import siteService from '@/project/site/site.service';
import Api from '@/project/http/Api.service';
import serverContext from '@/core/serverContext.service';
import { LegalContentViewModel } from '@/types/apiServerContract';

const props = defineProps({
    content: {
        type: Object as PropType<LegalContentBlockViewModel>,
        required: true
    },
    parentAlias: {
        type: String,
        required: false,
        default: null
    }
});

const translatedContent = ref<LegalContentViewModel | null>(null);
const showTranslated = ref<boolean>(false);

function bodyText(html: string): string {
    return tableHtmlService.wrapTableInOuterDivs(html);
}

async function translateDescription() {
    if (translatedContent.value === null) {
        const translation = await Api.translate.translateLegalContent(props.content.pageId, serverContext.siteInfo.languageCode || '');
        translatedContent.value = translation || null;
    }

    showTranslated.value = !showTranslated.value;
}

const showTranslationButton = computed(() => serverContext.siteInfo?.languageCode !== 'en');

const labelForTranslateDescription = computed(():string => {
    const languageTargetString = dictionaryService.languageNameByLanguageCode(siteService.getLanguageCode()?.toLowerCase() || '');
    return showTranslated.value
        ? dictionaryService.get('Product.Details.Translate.ShowOriginal')
        : dictionaryService.get('Product.Details.Translate', [languageTargetString]);
});
</script>
